import { useBlastStore } from "@fetch/blast/store";
import { useInterproStore } from "@fetch/interpro/store";
import { useJobStore } from "@jobs/store";
import { type ImportStatus, useImportStore } from "@upload/importStore";
import { useEffect } from "react";

const activeImportStatuses: ImportStatus[] = [
  "pending",
  "staging",
  "detecting",
  "ingesting",
];

/**
 * Prompts the browser's native confirmation dialog when the user tries to
 * close the tab or refresh while background tasks are running.
 */
export function useWarnBeforeUnload() {
  const hasActiveJobs = useJobStore((s) =>
    s.jobs.some((job) => job.status === "pending" || job.status === "running"),
  );

  const hasActiveImports = useImportStore((s) =>
    s.imports.some((item) => activeImportStatuses.includes(item.status)),
  );

  const hasActiveBlastSearches = useBlastStore(
    (s) => s.getPendingSearches().length > 0,
  );

  const hasActiveInterproSearches = useInterproStore(
    (s) => s.getPendingSearches().length > 0,
  );

  const hasRunningTasks =
    hasActiveJobs ||
    hasActiveImports ||
    hasActiveBlastSearches ||
    hasActiveInterproSearches;

  useEffect(() => {
    if (!hasRunningTasks) return;

    function handleBeforeUnload(e: BeforeUnloadEvent) {
      e.preventDefault();
    }

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [hasRunningTasks]);
}
